import {
  COLLAPSE_SIDEBAR_REQUEST,
  COLLAPSE_SIDEBAR_RESET,
  DOCKED_SIDEBAR_DESKTOP,
  DOCKED_SIDEBAR_MOBILE,
} from './../../constants'

export function setCollapseSidebar(data) {
  return {
    type: COLLAPSE_SIDEBAR_REQUEST,
    payload: data,
  }
}
export function resetCollapseSidebar() {
  return {
    type: COLLAPSE_SIDEBAR_RESET,
  }
}

export const setDocked = payload => ({
  type: DOCKED_SIDEBAR_DESKTOP,
  payload,
})

export const setDockedMobile = payload => ({
  type: DOCKED_SIDEBAR_MOBILE,
  payload,
})



// WEBPACK FOOTER //
// ./src/actions/sidebar/sidebar-action.js